import script from "./MobileField.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileField.vue?vue&type=script&setup=true&lang=js"

import "./MobileField.vue?vue&type=style&index=0&id=62f6c4d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f6c4d6"]])

export default __exports__